import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { WhopIframeSdkProvider } from '@whop/react';
import { Theme } from 'frosted-ui';
import App from './App';
import './index.css';

// Extract basename from URL for Whop dashboard embedding
// URL format: /dashboard/biz_xxx/... or /dashboard/biz_xxx
const getBasename = () => {
  const pathname = window.location.pathname;
  const match = pathname.match(/^(\/dashboard\/biz_[a-zA-Z0-9]+)/);
  return match ? match[1] : '';
};

const basename = getBasename();
console.log('[Router] Using basename:', basename);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <WhopIframeSdkProvider>
        <Theme
          appearance="dark"
          accentColor="iris"
          grayColor="slate"
          successColor="green"
          warningColor="yellow"
          dangerColor="red"
        >
          <App />
        </Theme>
      </WhopIframeSdkProvider>
    </BrowserRouter>
  </React.StrictMode>
);
